module.exports = __webpack_public_path__ + "static/media/logo_white_full_lg_2025.8f63c922.png";